import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=8903635a&scoped=true&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"
import style0 from "./checkbox.vue?vue&type=style&index=0&id=8903635a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8903635a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8903635a')) {
      api.createRecord('8903635a', component.options)
    } else {
      api.reload('8903635a', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=8903635a&scoped=true&", function () {
      api.rerender('8903635a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/checkbox.vue"
export default component.exports